import type {
  CommunityEventNotificationSubtype,
  Notification,
} from '@models/community/notification.model';

export interface NotificationBadgeView {
  label: string;
  cssClass: string;
}

export interface CommunityEventNotificationChrome {
  applyR7: boolean;
  badges: NotificationBadgeView[];
  sourceLabel: string | null;
  canSeeDetails: boolean;
  eventName: string | null;
}

const EMPTY_CHROME: CommunityEventNotificationChrome = {
  applyR7: false,
  badges: [],
  sourceLabel: null,
  canSeeDetails: true,
  eventName: null,
};

export function resolveCommunityEventNotificationChrome(
  item: Notification,
): CommunityEventNotificationChrome {
  if (item.type !== 'CommunityEvent') {
    return EMPTY_CHROME;
  }

  const eventName = item.model?.name ?? null;
  const subtype = item.content?.data?.subtype;

  if (!subtype) {
    return {
      ...EMPTY_CHROME,
      eventName,
    };
  }

  return chromeForSubtype(subtype, eventName);
}

function chromeForSubtype(
  subtype: CommunityEventNotificationSubtype,
  eventName: string | null,
): CommunityEventNotificationChrome {
  switch (subtype) {
    case 'GUEST_CONFIRMED':
      return {
        applyR7: true,
        badges: [{ label: 'RSVP w/Guest', cssClass: 'badge bg-primary' }],
        sourceLabel: null,
        canSeeDetails: true,
        eventName,
      };
    case 'EVENT_CANCELLED':
      return {
        applyR7: true,
        badges: [{ label: 'Cancelled', cssClass: 'badge bg-danger' }],
        sourceLabel: 'By Community',
        canSeeDetails: false,
        eventName,
      };
    case 'RSVP_CANCELLED_BY_COMMUNITY':
      return {
        applyR7: true,
        badges: [{ label: 'Cancelled', cssClass: 'badge bg-danger' }],
        sourceLabel: 'By Community',
        canSeeDetails: true,
        eventName,
      };
    case 'GUEST_DECLINED':
      return {
        applyR7: true,
        badges: [{ label: 'Declined', cssClass: 'badge bg-danger' }],
        sourceLabel: 'by Guest',
        canSeeDetails: true,
        eventName,
      };
    default:
      return {
        ...EMPTY_CHROME,
        eventName,
      };
  }
}
